import { render, staticRenderFns } from "./IndustryNavigationDetail.vue?vue&type=template&id=731a64a9&"
import script from "./IndustryNavigationDetail.vue?vue&type=script&lang=js&"
export * from "./IndustryNavigationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports